var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsulinResistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F3A28A;}\n\t.st1{fill:#E6393D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,183.2c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.7,148.7,63.5,183.2,106.3,183.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107,56.3c-0.3,0.4-0.5,0.7-0.7,0.9c-9.5,14.7-19,29.3-28.4,44c-2.9,4.5-4.5,9.6-4.9,15 c-1.8,21.6,16.6,39.3,38.2,36.7c24.9-3,38.2-31.3,24.5-52.4c-3.3-5.1-6.6-10.3-9.9-15.4C119.5,75.6,113.3,66.1,107,56.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107,56.3c6.3,9.8,12.5,19.3,18.7,28.8c3.3,5.1,6.6,10.3,9.9,15.4c13.7,21,0.5,49.4-24.5,52.4 c-21.6,2.6-39.9-15.1-38.2-36.7c0.4-5.4,2-10.4,4.9-15c9.5-14.7,19-29.3,28.4-44C106.5,57,106.7,56.7,107,56.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsulinResistance);
export default __webpack_public_path__ + "static/media/Insulin_Resistance.86a73bfb2be3358d085439ebb89a8c82.svg";
export { ForwardRef as ReactComponent };